import script from "./ContactLocation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactLocation.vue?vue&type=script&setup=true&lang=ts"

import "./ContactLocation.vue?vue&type=style&index=0&id=64330771&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64330771"]])

export default __exports__